<template>
  <Transition>
    <component :is="this.$route.meta.layout || layout">
      <slot />
    </component>
  </Transition>
</template>

<script src="./App.js"></script>
<style src="./App.scss" lang="scss"></style>